import React from "react";
import PageWrapperComponent from "@src/components/organisms/page-wrapper/page-wrapper.component";
import DataGridComponent from "@molecules/data-grid/data-grid.component";
import FeatherIcon from "feather-icons-react";
import PageHeadComponent from "@src/components/organisms/page-head/page-head.component";
import ModalComponent from "@atoms/modal/modal.component";

function FileUploadTemplateComponent({
  templateModal: { 
    tableTitle, 
    keyColumn, 
    breadCrumbs, 
    tableColumn, 
    tableData, 
    totalCount, 
    filters, 
    categories,
  },
  templateEvents: { 
    getFileUploadData, 
    deleteRecords, 
    submitFilter,
  },
}) {
  const ActionContent = () => (
    <>
    </>
  );

  return (
    <>
      <PageWrapperComponent>
        <PageHeadComponent 
          title="File Upload" 
          breadCrumbs={breadCrumbs} 
          actionContent={<ActionContent />} 
        />
        <DataGridComponent
          title={tableTitle}
          keyColumn={keyColumn}
          tableData={tableData}
          tableColumn={tableColumn}
          totalCount={totalCount}
          dataRefresh={getFileUploadData}
          deleteRecords={deleteRecords}
          breadCrumbs={breadCrumbs}
          filters={filters}
          submitFilter={submitFilter}
          extraData={{ categories }}
        />
      </PageWrapperComponent>
    </>
  );
}

export default FileUploadTemplateComponent;